import React from "react";
import { Button, Dialog, DialogContent, Link, makeStyles, Typography } from "@material-ui/core";
var useStyles = makeStyles({
  paper: {
    width: "600px",
    maxWidth: "550px",
    borderRadius: "10px"
  },
  content: {
    backgroundColor: "#F3F4F5",
    padding: "32px"
  },
  title: {
    marginTop: "18px",
    fontSize: "32px",
    fontWeight: 500,
    lineHeight: "40px",
    color: "#0C2340",
    marginBottom: "20px"
  },
  body: {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "24px",
    color: "#0C2340",
    marginBottom: "20px"
  },
  link: {
    display: "block",
    marginBottom: "20px",
    color: "#0e5fc1",
    textDecoration: "underline",
    wordBreak: "break-all",
    fontSize: "16px"
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "16px",
    marginTop: "20px"
  },
  cancelButton: {
    borderRadius: "6px",
    borderColor: "#cdcdcd",
    color: "#0C2340",
    textTransform: "none",
    minWidth: "80px"
  },
  continueButton: {
    borderRadius: "4px",
    backgroundColor: "#0C2340",
    color: "#FFFFFF",
    textTransform: "none",
    minWidth: "220px",
    "&:hover": {
      backgroundColor: "#0C2340"
    }
  }
});
var AccessDeniedModal = function AccessDeniedModal(_ref) {
  var opened = _ref.opened,
    onClose = _ref.onClose,
    v2LoginUrl = _ref.v2LoginUrl;
  var classes = useStyles();
  return React.createElement(Dialog, {
    open: opened,
    onClose: onClose,
    maxWidth: false,
    classes: {
      paper: classes.paper
    }
  }, React.createElement(DialogContent, {
    className: classes.content
  }, React.createElement(Typography, {
    className: classes.title
  }, "Let\u2019s get you to the Right Portal"), React.createElement(Typography, {
    className: classes.body
  }, "We found your account; it's just linked to a different Baylor Genetics provider portal. Sign in here to pick up where you left off:"), v2LoginUrl && React.createElement(Link, {
    href: v2LoginUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    className: classes.link
  }, v2LoginUrl), React.createElement(Typography, {
    className: classes.body
  }, "Tip: Bookmark this link to skip the redirect next time."), React.createElement("div", {
    className: classes.actions
  }, React.createElement(Button, {
    variant: "outlined",
    className: classes.cancelButton,
    onClick: onClose
  }, "Cancel"), React.createElement(Button, {
    variant: "contained",
    className: classes.continueButton,
    onClick: function onClick() {
      window.location.href = v2LoginUrl;
    }
  }, "Continue to Provider Portal"))));
};
export default AccessDeniedModal;